import {BaseHook, Hook, HookClass, NickProcessArtfact} from '@mrp-brasil/nick-process-commons';
import {Observable, of} from 'rxjs';

@HookClass('dummy')
export class DummyHook extends BaseHook {

    @Hook('5a60f96e-5be5-46f4-a9fc-500c2d7ca6b3')
    public dummy(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return of(inputArtifact);
    }
}
